import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MarginCalculatorState } from '../state/margin-calculator.state';
import { marginCalculatorFeatureKey } from './margin-calculator.feature';
import { MarginState } from '../state/margin-state';

const selectMarginCalculatorState = createFeatureSelector<MarginCalculatorState>(marginCalculatorFeatureKey);

export const selectLoadedMargin = createSelector(
    selectMarginCalculatorState,
    (state: MarginCalculatorState) => state.loadedMargin
);

export const selectLoadedMarginExists = createSelector(selectLoadedMargin, (margin: MarginState) => !!margin?.version);

export const selectLoadedMarginOnCallPayRate = createSelector(
    selectLoadedMargin,
    (margin: MarginState) => margin?.onCallPayRate
);
